// @file Surface user contributors store
import { getVuexStore } from '@@/bits/pinia'
import { defineStore } from 'pinia'
import type { Id, User } from 'types'
import { computed } from 'vue'
import type { RootState } from 'vuexstore/surface/types'

export const useSurfaceUserContributorsStore = defineStore('surfaceUserContributors', () => {
  const surfaceVuexStore = getVuexStore<RootState>()

  // getters
  const postAuthors = computed<User[]>(() => surfaceVuexStore?.getters['userContributor/postAuthors'])
  const postAuthorsById = computed<Record<Id, User>>(() => {
    const authors = postAuthors.value
    return authors.reduce<Record<Id, User>>((acc, author) => {
      acc[author.id] = author
      return acc
    }, {})
  })

  // getter functions
  function getUserById(id: Id): User | null {
    return surfaceVuexStore?.getters['userContributor/getUserById'](id)
  }

  // actions
  function fetchPostAuthors(): void {
    void surfaceVuexStore?.dispatch('userContributor/fetchPostAuthors')
  }

  function fetchAndWaitForAuthors(): void {
    void surfaceVuexStore?.dispatch('userContributor/fetchAndWaitForAuthors')
  }

  return {
    // getters
    postAuthors,
    postAuthorsById,

    // getter functions
    getUserById,

    // actions
    fetchPostAuthors,
    fetchAndWaitForAuthors,
  }
})
